module.exports = __webpack_public_path__ + "img/bus-simple.939ec6ef.svg";